import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTiposFortalezaThunk,
  fetchTiposSubFraseThunk,
  fetchFrasesThunk,
  createFraseThunk,
  updateFraseThunk,
  toggleFraseActiveThunk,
  fetchFrasesSelectorThunk,
  fetchSubFrasesThunk,
  createSubFraseThunk,
  updateSubFraseThunk,
  toggleSubFraseActiveThunk,
  fetchOpcionesRespuestaThunk,
  updateOpcionRespuestaThunk,
} from "./preguntasTalento.thunks";

const paginated = () => ({ results: [], count: 0, next: null, previous: null });

const initialState = {
  tiposFortaleza: [],
  tiposSubFrase: [],
  frases: { data: paginated(), loading: false, error: null, selector: [] },
  subFrases: { data: paginated(), loading: false, error: null },
  opciones: { items: [], loading: false, error: null },
};

const replaceInResults = (results, updated) =>
  results.map((item) => (item.id === updated.id ? { ...item, ...updated } : item));

const slice = createSlice({
  name: "preguntasTalento",
  initialState,
  reducers: {
    resetPreguntasTalentoState: () => initialState,
  },
  extraReducers: (builder) => {
    // TIPOS DE FORTALEZA
    builder.addCase(fetchTiposFortalezaThunk.fulfilled, (s, a) => {
      s.tiposFortaleza = a.payload || [];
    });

    // TIPOS DE SUB-FRASE
    builder.addCase(fetchTiposSubFraseThunk.fulfilled, (s, a) => {
      s.tiposSubFrase = a.payload || [];
    });

    // FRASES
    builder
      .addCase(fetchFrasesThunk.pending, (s) => { s.frases.loading = true; s.frases.error = null; })
      .addCase(fetchFrasesThunk.fulfilled, (s, a) => { s.frases.loading = false; s.frases.data = a.payload; })
      .addCase(fetchFrasesThunk.rejected, (s, a) => { s.frases.loading = false; s.frases.error = a.payload; })
      .addCase(fetchFrasesSelectorThunk.fulfilled, (s, a) => {
        s.frases.selector = Array.isArray(a.payload) ? a.payload : a.payload.results || [];
      })
      .addCase(createFraseThunk.fulfilled, (s, a) => {
        s.frases.data.results = [a.payload, ...s.frases.data.results];
        s.frases.data.count += 1;
      })
      .addCase(updateFraseThunk.fulfilled, (s, a) => {
        s.frases.data.results = replaceInResults(s.frases.data.results, a.payload);
      })
      .addCase(toggleFraseActiveThunk.fulfilled, (s, a) => {
        s.frases.data.results = replaceInResults(s.frases.data.results, a.payload);
      });

    // SUB-FRASES
    builder
      .addCase(fetchSubFrasesThunk.pending, (s) => { s.subFrases.loading = true; s.subFrases.error = null; })
      .addCase(fetchSubFrasesThunk.fulfilled, (s, a) => { s.subFrases.loading = false; s.subFrases.data = a.payload; })
      .addCase(fetchSubFrasesThunk.rejected, (s, a) => { s.subFrases.loading = false; s.subFrases.error = a.payload; })
      .addCase(createSubFraseThunk.fulfilled, (s, a) => {
        s.subFrases.data.results = [a.payload, ...s.subFrases.data.results];
        s.subFrases.data.count += 1;
      })
      .addCase(updateSubFraseThunk.fulfilled, (s, a) => {
        s.subFrases.data.results = replaceInResults(s.subFrases.data.results, a.payload);
      })
      .addCase(toggleSubFraseActiveThunk.fulfilled, (s, a) => {
        s.subFrases.data.results = replaceInResults(s.subFrases.data.results, a.payload);
      });

    // OPCIONES SÍ/NO
    builder
      .addCase(fetchOpcionesRespuestaThunk.pending, (s) => { s.opciones.loading = true; s.opciones.error = null; })
      .addCase(fetchOpcionesRespuestaThunk.fulfilled, (s, a) => {
        s.opciones.loading = false;
        s.opciones.items = Array.isArray(a.payload) ? a.payload : a.payload.results || [];
      })
      .addCase(fetchOpcionesRespuestaThunk.rejected, (s, a) => { s.opciones.loading = false; s.opciones.error = a.payload; })
      .addCase(updateOpcionRespuestaThunk.fulfilled, (s, a) => {
        s.opciones.items = s.opciones.items.map((o) => (o.id === a.payload.id ? a.payload : o));
      });
  },
});

export const { resetPreguntasTalentoState } = slice.actions;
export default slice.reducer;
